import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { ApplicationTextType } from '../../languages/IApplicationText';
import { AudioPlayerService } from '../../services/audio-player.service';
import { GameService } from '../../services/game.service';
import { Level } from '../../_models/model';

@Component({
  selector: 'app-game-level-completed',
  templateUrl: './game-level-completed.component.html',
  styleUrls: ['./game-level-completed.component.less']
})
export class GameLevelCompletedComponent implements OnInit {
  @Input() activeLevelNumber!: number;
  gameIcon!: string;
  gameFinishedTextAanvulling!: SafeHtml;
  gameFinishedText!: SafeHtml;
  level!: Level;
  @Output() close = new EventEmitter<boolean>();
  constructor(public audio: AudioPlayerService, private gameService: GameService) { }
  downloaded = false;
  ngOnInit(): void {
    this.gameIcon = `/img/popup/won-level-types/Voorwerp_level_${this.activeLevelNumber + 1}.svg`;
    this.gameFinishedText = this.audio.getHTML('level' + this.activeLevelNumber + '_afgerond' as ApplicationTextType);
    this.gameFinishedTextAanvulling = this.audio.getHTML('level_afgerond_' + this.activeLevelNumber as ApplicationTextType)
    this.level = this.gameService.getLevel(this.activeLevelNumber);
    if (!this.level.worksheet) {
      this.downloaded = true;
    }
  }

  onClose() {
    if (this.downloaded) {
      this.close.emit(true);
    }
  }
  printWerkblad() {
    if (this.level.worksheet) {
      window.open(environment.staticUrl + 'static/worksheet/' + this.level.order + '?f' + this.level.worksheet);
    }
    this.downloaded = true;
  }

}
